
const benefits = [
  {
    icon: 'ri-user-star-line',
    title: 'Expert Guidance',
    description: 'Our top-rated agencies have decades of combined experience helping Houston residents find the perfect health insurance coverage.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Cost Savings',
    description: 'Specialized in helping higher earners reduce premium costs while maintaining comprehensive coverage and benefits.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Self-Employed Focus',
    description: 'Tailored solutions for entrepreneurs, freelancers, and independent contractors with unique insurance needs.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Private Insurance Specialists',
    description: 'Deep expertise in individual and family plans, dental, vision, and comprehensive private health insurance options.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Personalized Service',
    description: 'One-on-one consultations to understand your specific needs and find coverage that fits your lifestyle and budget.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Local Houston Expertise',
    description: 'In-depth knowledge of Houston-area providers, networks, and coverage options specific to Texas residents.',
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-choose" className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Houston's Top Agencies
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover the advantages of working with Houston's premier health insurance experts
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-teal-200"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-200">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Ready to Find Your Perfect Plan?
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Our #1 ranked Houston Health Insurance Experts are standing by to help you navigate your options and find coverage that fits your needs and budget. Whether you're self-employed, a higher earner looking to reduce costs, or simply seeking better private insurance, we're here to help.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="tel:2812062619" className="bg-teal-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-600 transition-colors text-center whitespace-nowrap cursor-pointer">
                  Call (281) 206-2619
                </a>
                <a href="#contact" className="bg-gray-100 text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors text-center whitespace-nowrap cursor-pointer">
                  Schedule Consultation
                </a>
              </div>
            </div>
            <div className="relative h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/1334e459b9b1a19d484f17ebb06fa542.jpg"
                alt="Happy Client"
                className="w-full h-full object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
